export default __webpack_public_path__ + "media/titles/title_6_locale_da-aa1384ba.png";